export enum SolutionStatus {
  PUBLISHED = 'published',
  dev = "dev",
  COMING_SOON = 'comingsoon',
}
